import { Component, OnInit, ElementRef, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { PageBase, UIService, RentalInfo, CacheService, PhotoAngle, PhotoAngleInfo } from 't4core';
import { NavigationService } from 'app-components';
import { AppIntegrationService } from 't4-app-integration';
import { Router, ActivatedRoute } from '@angular/router';
import { ActiveRentalService } from 'app-components';
import { LayoutService } from 'app-components';
import { MatStepper } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { PhotoViewComponent } from '../../Components/photo-view/photo-view.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

export class PhotoModel {
  public angle: PhotoAngleInfo;
  public photoUri: string;
  public data?: string;
  public taken?: boolean;
  public control: FormControl;
}

@Component({
    selector: 'app-take-pictures',
    templateUrl: './take-pictures.component.html',
    styleUrls: ['./take-pictures.component.css'],
    providers: [{
            provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
        }],
    standalone: false
})                    
export class TakePicturesComponent extends PageBase implements OnInit {

  @ViewChildren(PhotoViewComponent) appPhotoViewComponents: QueryList<PhotoViewComponent>;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  public currentStep: number = 0;

  public ignoreCameraCheck: boolean = false;  
  public permissionAsked: boolean = false; 
   

  public event: string = "Pickup"; 
  public booking: RentalInfo;

  public photosTaken: number = 0;
  public photos: PhotoModel[] = []; 

  public additionalPhotosArray: PhotoModel[] = [];

  public isSummaryStep: boolean = false;

  public fallbackImage: string = "/Images/fallback-image-photo.png";

  constructor(el: ElementRef, private router: Router, private aviationService: NavigationService, public appService: AppIntegrationService, private ui: UIService, private rentalService: ActiveRentalService, private route: ActivatedRoute, private layoutService: LayoutService, private formBuilder: FormBuilder) {
    super(el);
    this.appService.requestDeviceState();

    this.event = this.aviationService.getParam("event");

    this.additionalPhotosArray.push({ angle: null, photoUri: null, control: new FormControl('') });
  }

  async ngOnInit() {
    this.booking = await this.rentalService.getBooking();

    // Load cached data
    var tmp = this.rentalService.getCached("RP_photoList");
    if (tmp) {
      this.photos = tmp.data;
    }

    tmp = this.rentalService.getCached("RP_addPhotoList");
    if (tmp) {
      this.additionalPhotosArray = tmp.data;
    } 

    if (this.photos.length <= 0) {
      var token = this.UI.beginLoading("Intellitrailer.PhotoAngle.LoadingAnglesMsg", "Loading Angles", null);
      
      if (this.event != "Pickup") {

   

        // Type - PhotoAngleInfo
        var angles = await this.rentalService.getPhotoAngles();
        angles.map(x => this.photos.push({ angle: x, photoUri: '', control: new FormControl('') }));

        //Updated the values and settings a "required" condition.
        this.photos.map(x => x.control.setErrors({ "required": true }));
      }

      this.rentalService.storeWithRental("RP_photoList", this.photos, new Date(new Date().getTime() + 10 * 60 * 1000));
      this.rentalService.storeWithRental("RP_addPhotoList", this.additionalPhotosArray, new Date(new Date().getTime() + 10 * 60 * 1000));
      

      this.UI.loaderCompleted(token);
    }

    // Move to current photo
    setTimeout(async () => {
      var i = 0;
      var stopped = false;
      for (var item of this.photos) {
        item.control = new FormControl('');

        if (item.photoUri || item.taken) {
          if (!stopped) {
            this.stepper._steps.get(i)._markAsInteracted();
            this.photoTaken(item);
          }

          item.control.reset();
        } else {
          stopped = true;
          item.control.setErrors({ "required": true });
        }
      }

      for (var item of this.additionalPhotosArray) {
        item.control = new FormControl('');

        if (item.photoUri || item.taken) {
          item.control.reset();
        } else {
          item.control.setErrors({ "required": true });
        }
      }

      // Anything in pipeline?
      setTimeout(() => this.checkForPending(), 1000);

      console.log("Stepper");
      console.log(this.stepper);
      console.log(this.stepper?.selected);
    }, 100);
  }

  private async checkForPending(): Promise<Boolean> {
    var photo = this.appService.findPendingPhoto();
    if (photo) {
      var angle = null;

      for (var a of this.photos) {
        if (!a.photoUri) {
          angle = a;
          break;
        }
      }

      if (angle) {
        angle.photoUri = this.Api.post<string>("Data/Store" + this.event + "Photo", "\"" + photo.Image + "\"", { angleId: angle.angle.Id, rentalId: this.booking.Id });
        angle.data = photo.Image;
        angle.taken = true;
        this.photoTaken(angle);

        return true;
      } else if (this.additionalPhotosArray) {
        angle = this.additionalPhotosArray[this.additionalPhotosArray.length - 1];
        angle.photoUri = await this.Api.post<string>("Data/Store" + this.event + "Photo", "\"" + photo.Image + "\"", { angleId: 0, rentalId: this.booking.Id });
        angle.data = photo.Image;
        this.additionalPhotoTaken(this.additionalPhotosArray.length - 1);

        return true;
      }
    } else if (!this.rentalService.secretSafetyCheckFlag) {
      this.Insights.trackTrace("App restarted; Missing photo!");
    }

    return false;
  }
 
  ngAfterViewInit() {
  }

   
  onSelectionChange(event: StepperSelectionEvent) {
    // If user navigates away from a step that had an open camera, ensure we close it.
    try {
      const prevIndex = event?.previouslySelectedIndex;
      if (typeof prevIndex === 'number' && prevIndex >= 0 && prevIndex < this.photos.length && this.appPhotoViewComponents && this.appPhotoViewComponents.length > 0) {
        const prevPhoto = this.photos[prevIndex];
        if (prevPhoto) {
          const prevChild = this.appPhotoViewComponents.find(x => x.photo === prevPhoto);
          if (prevChild && prevChild.cameraOpen) {
            try { prevChild.cancelBrowserCamera(); } catch { /* ignore */ }
          }
        }
      }
    } catch {
    }

    //Controlls the Confirm/Submit button, as it should only show when get to the last step (summary)
    if (event.selectedIndex === this.photos.length) {
      this.isSummaryStep = true;
    } else {
      this.isSummaryStep = false;
    }
  }

  public async confirm() {
    // TODO Validate pictures

    //Fault report
    if (this.event == "FaultReport")
      this.UI.alert("Intellitrailer.FaultReport.SuccessHeadLine", "Fault report sent", "Intellitrailer.FaultReport.SuccessMessage", "The fault report has been sent. We thank you for contributing.");

    this.aviationService.executeCommand("Confirm");
  }

  public photoTaken(photo : PhotoModel) {
    this.photosTaken++;

    if (this.event != "Pickup") {
      photo.control.reset();
      this.stepper.next();
    }

    this.rentalService.storeWithRental("RP_photoList", this.photos, new Date(new Date().getTime() + 10 * 60 * 1000));
  }

  public photoFailed() {
    this.ignoreCameraCheck = false;
  }


  public photoDeleted(photo: PhotoModel) {
    this.photosTaken--;

    //If the Index does exist, we remove it and updated the formControl.
    photo.control.setErrors({ "required": true })

    this.rentalService.storeWithRental("RP_photoList", this.photos, new Date(new Date().getTime() + 10 * 60 * 1000));
  }

 
  public additionalPhotoTaken(index: number) {
    this.additionalPhotosArray.push({ angle: null, photoUri: null, control: new FormControl('') });

    this.rentalService.storeWithRental("RP_addPhotoList", this.additionalPhotosArray, new Date(new Date().getTime() + 10 * 60 * 1000));
  }

  public additionalPhotoDeleted(photo: PhotoModel) {
    this.additionalPhotosArray.splice(this.additionalPhotosArray.indexOf(photo), 1);

    this.rentalService.storeWithRental("RP_addPhotoList", this.additionalPhotosArray, new Date(new Date().getTime() + 10 * 60 * 1000));
  }

  // Takes Photo, when pressing the "Take Photo" Button.
  // Work around to instead have it inside the mat-stepper, loading issues.
    public async simulateChildClick() {
        if (this.appService.Device.Camera < 2) {
            this.permissionAsked = true;
        }

    var currentPhoto = this.photos.find(x => x.control == this.stepper.selected?.stepControl)
    const selectedAppPhotoView = this.appPhotoViewComponents.find(x => x.photo == currentPhoto);

    if (selectedAppPhotoView) {
      try {
        // If camera is not started, start it. If already started, take picture.
        if (!selectedAppPhotoView.cameraOpen) {
          await selectedAppPhotoView.startBrowserCamera();
        } else {
          await selectedAppPhotoView.captureAndUpload();
        }
      } catch (ex) {
        // If something goes wrong, notify parent view
        this.photoFailed();
      }
    }
  }

  // Getter used by template to decide label for the action button
  public get currentChildCameraOpen(): boolean {
    try {
      const currentPhoto = this.photos.find(x => x.control == this.stepper?.selected?.stepControl);
      if (!currentPhoto || !this.appPhotoViewComponents) return false;
      const selectedAppPhotoView = this.appPhotoViewComponents.find(x => x.photo == currentPhoto);
      return !!selectedAppPhotoView?.cameraOpen;
    } catch {
      return false;
    }
  }

  public goToStep(index: PhotoModel) {
    this.currentStep = this.photos.indexOf(index);
  }

  public skipCameraCheck() {
    this.ignoreCameraCheck = true;
  }
  public checkCameraPermission() {
    if (this.appService.Device.Camera < 2) {
      this.permissionAsked = true;
    }
  }

  public skipTakePictures() {
    if (this.appService.Device.Camera < 2) {
      this.aviationService.executeCommand("Confirm");
    }
  }
 
}
